import { useRef } from 'react';
import HeroSection from './sections/HeroSection';
import BedSection from './sections/BedSection';
import BeddingSection from './sections/BeddingSection';
import BathSection from './sections/BathSection';
import SpaSection from './sections/SpaSection';
import BathBodySection from './sections/BathBodySection';
import GamesSection from './sections/GamesSection';
import LeScoopSection from './sections/LeScoopSection';
import GoldenHourSection from './sections/GoldenHourSection';
import SeoSection from './sections/SeoSection';
import useAnimate from '@Hotels-at-Home/hah-fe-core/dist/hooks/useAnimate';
import { IGetPromotionResponse } from '@Hotels-at-Home/hah-fe-core/dist/types';

interface IProps {
  promotion: IGetPromotionResponse;
}

const Home = ({ promotion }: IProps) => {
  const animateRef = useRef(null);
  useAnimate(animateRef);

  return (
    <div id="home" ref={animateRef}>
      <HeroSection />
      <BedSection />
      <BeddingSection />
      <BathSection />
      <SpaSection />
      <BathBodySection />
      <GamesSection />
      <LeScoopSection />
      <GoldenHourSection />
      <SeoSection />
    </div>
  );
};

export default Home;
